import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Home.css';
import Navbar from './Navbar';
import Footer from './Footer';
import PitchContainer from './PitchContainer';
import BrandContainer from './BrandContainer';
import WhyContainer from './WhyContainer';
import HowToContainer from './HowToContainer';
import Testimonial from './Testimonial';
import Pricing from './Pricing';
import FAQ from './FAQ';
import StartNow from './StartNow';
import Grid from './Grid';


function Home() {
  const [searchParams] = useSearchParams();
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);

  useEffect(() => {
    // Check if redirected from payment success
    if (searchParams.get('payment') === 'success') {
      setShowPaymentSuccess(true);
      // Auto-hide after 10 seconds
      setTimeout(() => {
        setShowPaymentSuccess(false);
      }, 10000);
    }
  }, [searchParams]);

  return (
    <div className="Home">
      {showPaymentSuccess && (
        <div className="payment-success-banner">
          <div className="payment-success-message">
            <h3>🎉 Payment Successful!</h3>
            <p>Your subscription is now active. Please sign in to access your dashboard.</p>
            <button 
              onClick={() => setShowPaymentSuccess(false)}
              className="close-banner"
            >
              ×
            </button>
          </div>
        </div>
      )}
      <Grid />
      <Navbar />
      <PitchContainer/>
      <BrandContainer/>
      <WhyContainer/>
      <HowToContainer/>
      <Testimonial/>
      <Pricing/>
      <FAQ/>
      <StartNow/>
      <Footer />
    </div>
  );
}

export default Home;


// eslint-disable-next-line